export default __webpack_public_path__ + "static/media/pantstain-active.32d6e0ef.png";